import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'reference-payment.detail',
    country: ['PH', 'CO', 'DO']
  },
  {
    feature: 'payments.pse-new-functionalities',
    country: ['PH', 'DO', 'CR', 'GB', 'CO'],
  },
  {
    feature: 'payments.worflow-v4',
    country: ['CO','DO']
  },
  {
    feature: 'payments.worflow-v4',
    country: ['PH'],
    environment: ['Development','Quality']
  },
  {
    feature: 'payments.pse-new-functionalities',
    country: ['GB']
  },
  {
    feature: 'payments.disable-banklist-to-transfer-method',
    country: ['CO','DO','PH']
  },
  {
    feature: 'payments.steps-show-reference-number',
    country: ['MX']
  },

  {
    feature: 'recocile.disable-jobsiteCode-parameter',
    country: ['AE']
  },

  {
    feature: 'payment-history.table-column.ticket-id',
    country: ['CO']
  },
  {
    feature: 'payments.filter-payment-methods',
    country: ['MX'],
    options: [
      {
        companies: ['3085'],
        paymentMethods: ['TRANSFER', 'REFERENCE']
      }
    ]
  },
  {
    feature: 'payments.filter-payment-methods-7277',
    country: ['MX'],
    options: [
      {
        companies: ['7277'],
        paymentMethods: ['TRANSFER', 'REFERENCE']
      }
    ]
  },
  {
    feature: 'payments.filter-payment-methods-7100',
    country: ['MX'],
    options: [
      {
        companies: ['7100'],
        paymentMethods: ['TRANSFER', 'REFERENCE']
      }
    ]
  },
  {
    feature: 'payments.filter-payment-methods-7146',
    country: ['MX'],
    options: [
      {
        companies: ['7146'],
        paymentMethods: []
      }
    ]
  },
  {
    feature: 'payments.filter-payment-methods-7283',
    country: ['MX'],
    options: [
      {
        companies: ['7283'],
        paymentMethods: []
      }
    ]
  },
  {
    feature: 'payments.filter-banks',
    country: ['MX'],
    options: [
      {
        companies: ['3085'],
        banks: ['BMR01']
      }
    ]
  },
  {
    feature: 'payments.filter-banks-3085',
    country: ['MX'],
    options: [
      {
        companies: ['3085'],
        banks: ['BMR01']
      }
    ]
  },
  {
    feature: 'payments.filter-banks-7100',
    country: ['MX'],
    options: [
      {
        companies: ['7100'],
        banks: ['BMR01','BMX01','STD01','BNT01']
      }
    ]
  },
  {
    feature: 'payments.filter-banks-7180',
    country: ['MX'],
    options: [
      {
        companies: ['7180'],
        banks: ['BMR01','BMX01','STD01','BNT01']
      }
    ]
  },
  {
    feature: 'payments.filter-banks-7277',
    country: ['MX'],
    options: [
      {
        companies: ['7277'],
        banks: ['BMR01','BMX01','STD01','BNT01']
      }
    ]
  },
  {
    feature: 'payments.filter-banks-7146',
    country: ['MX'],
    options: [
      {
        companies: ['7146'],
        banks: []
      }
    ]
  },
  {
    feature: 'payments.filter-banks-7283',
    country: ['MX'],
    options: [
      {
        companies: ['7283'],
        banks: []
      }
    ]
  },
  {
    feature: 'payments.filter-banks',
    country: ['US'],
    options: [
      {
        companies: ['7029'],
        banks: ['JPM','BOFA1']
      }
    ]
  },
  {
    feature: 'payments.skip-payment-method-step',
    country: ['US']
  },
  {
    feature: 'payments.change-logo-for-text',
    country: ['US']
  },
  {
    feature: 'payments.filter-external-app',
    country: ['CO'],
    options: {
      Construagil_App: ['7544']
    }
  },
  {
    feature: 'payments.disable-company-customer-select',
    country: ['DO','PH']
  },
  {
    feature: 'payments.filter-external-companies',
    country: ['CO'],
    options: {
      externalApp: 'Construagil_App',
      companies: ['7544']
    }
  },
  {
    feature: 'payments.filter-external-companies',
    country: ['DO','PH'],
    options: {
      externalApp: '',
      companies: []
    }
  },
  {
    feature: 'payments.v4.jobsite-required',
    country: ['CO','DO','PH']
  },
  {
    feature: 'payments.default-payment-company',
    country: ['CO'],
    options: {
      companies: []
    }
  },
  {
    feature: 'payments.default-payment-company',
    country: ['DO'],
    options: {
      companies: ['7725']
    }
  },
  {
    feature: 'payments.default-payment-company',
    country: ['PH'],
    options: {
      companies: []
    }
  },
  {
    feature: 'advanced-payments.location-information.sales-order',
    country: ['PH'],
  },
  {
    feature: 'payments.confirmation-dialog.show-total',
    country: ['PH'],
  },
  {
    feature: 'payments.confirmation-dialog.text',
    country: ['PH'],
    options: {
      translationLabel: 'views.regular_payments.troubleshoot_contact_info'
    }
  },
  {
    feature: 'advanced-payments.location-information.sales-order',
    country: ['PH'],
  },
  {
    feature: 'reference-payment.cancel_reference',
    country: ['MX']
  },
] as IAppConfiguration[];

